import { useQuery } from "@tanstack/react-query";
import { MINLENGTH_TO_SEARCH } from "../../../constants/env";
import * as productSearchApi from "./product-search.api";
import { buildProductSearchQueries } from "./product-search-query-builder";
import type { IProductSearchGeoContext } from "./product-search-geo-context.interface";
import { productSearchQueryKeys } from "./product-search.query-keys";
import type { IUseProductSearchQuery } from "./useProductSearch.query.interface";

export function useProductSearchQuery(
  searchText: string,
  geoContext?: IProductSearchGeoContext
): IUseProductSearchQuery {
  const enabled = searchText.length >= MINLENGTH_TO_SEARCH;

  function queryFn(): Promise<string[]> {
    const queries = buildProductSearchQueries(searchText, geoContext);
    return productSearchApi.multiSearchProductIdentifiers(queries);
  }

  const query = useQuery({
    queryKey: productSearchQueryKeys.search(searchText, geoContext),
    queryFn,
    enabled,
    keepPreviousData: true,
  });

  return {
    rankedUniqueIdentifiers: query.data,
    loading: query.isFetching,
    error: (query.error as Error) ?? null,
  };
}
